import { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ScrollToTop } from './components/foundation/ScrollToTop/ScrollToTop';
import { ErrorBoundary } from './components/foundation/ErrorBoundary/ErrorBoundary';
import { getCalApi } from "@calcom/embed-react";
import { CAL_CONFIG } from './constants/cal';


// const AetherLabPage = lazy(() => import('./pages/AetherLabPage/AetherLabPage'));
const FoundryPage = lazy(() => import('./pages/FoundryPage/FoundryPage'));
// const FoundryServicesPage = lazy(() => import('./pages/FoundryPage/FoundryServicesPage'));
const FoundryMVPPage = lazy(() => import('./pages/FoundryPage/FoundryMVPPage'));
const FoundryMigrationPage = lazy(() => import('./pages/FoundryPage/FoundryMigrationPage'));
// const FoundryExperimentsPage = lazy(() => import('./pages/FoundryPage/FoundryExperimentsPage'));
const FoundryProjectsPage = lazy(() => import('./pages/FoundryPage/FoundryProjectsPage'));
function App() {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi();
      cal("ui", CAL_CONFIG);
    })();
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route
            path="/"
            element={
              <Suspense fallback={null}>
                <FoundryPage />
              </Suspense>
            }
          />
          <Route
            path="/work"
            element={
              <Suspense fallback={null}>
                <FoundryProjectsPage />
              </Suspense>
            }
          />
          {/* <Route
            path="/services"
            element={
              <Suspense fallback={null}>
                <FoundryExperimentsPage />
              </Suspense>
            }
          /> */}
          <Route
            path="/mvp"
            element={
              <Suspense fallback={null}>
                <FoundryMVPPage />
              </Suspense>
            }
          />
          <Route
            path="/migration"
            element={
              <Suspense fallback={null}>
                <FoundryMigrationPage />
              </Suspense>
            }
          />

          {/* <Route
            path="/aether"
            element={
              <Suspense fallback={null}>
                <AetherLabPage />
              </Suspense>
            }
          /> */}
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
